import React, { lazy, Suspense } from 'react';
import coneIcon from 'assets/svg/cone.svg';

export type ModalProps = {
   url?: string;
};

const Modal = lazy(() => import('components/commons/modal'));

const ModalSafariRedirect: React.FC<ModalProps> = ({ url }): JSX.Element => (
    <Suspense fallback="">
        <Modal
            visible={true}
        >
            <div className="c-modal__inner--sm c-modal__body--center c-modal__inner--sm c-modal__body--center h-100 d-flex flex-column justify-content-center">
                <img className="icon mb-3" src={coneIcon} />
                <div className="mb-4 subtitle">
                    Ops
                </div>
                <div className="mb-4 body-2">
                    No iOS este processo está disponível apenas para o navegador Safari, por questões de compatibilidade com a câmera.
                </div>
                <a className="btn-biz primary" href={`safari://${url}`}>
                    acessar com o safari
                </a>
            </div>
        </Modal>
    </Suspense>
);

export default ModalSafariRedirect;
